import { Avatar, Box, Grid, Typography } from '@mui/material';
import React from 'react';

import imgbg from '../assets/images/section3/background.png';
import { Fade } from 'react-awesome-reveal';
import { Container } from '@mui/system';
import tokenLogo from '../assets/images/section3/Taral-Logo.png';

const cardData = [
  { title: 'Transaction Fees' },
  { title: 'Staking' },
  { title: 'Ecosystem Participation' },
  { title: 'Incentives' },
  { title: 'Validator Rewards' },
  { title: 'Governance' }
];

const Section3 = () => {
  return (
    <Box
      // sx={{ mt: { xs: 10, } }}
      sx={{ color: 'white', p: 3, mb: 14, pt: 14 }}
      style={{ background: `url(${imgbg})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}
      component={Fade}
    >
      <Container maxWidth="xl">
        <Grid container>
          <Grid item container xs={12} md={6} sx={{ flexDirection: 'column', alignItems: 'flex-start' }}>
            <Typography variant="h2" sx={{ fontSize: { xs: '48px', md: '68px' } }}>
              Introducing the most liquid, scarce, and valuable
            </Typography>
            <Typography variant="h2" sx={{ fontSize: '38px', border: '1px solid #707070', px: '10px', mt: '20px', mb: '10px' }}>
              TARAL
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: '500', width: { xs: '100%', sm: '40%', md: '50%' } }}>
              $TARAL is the native utility token of the Taralchain Network and serves as the lifeblood of the ecosystem.
            </Typography>
          </Grid>
          <Grid item container xs={12} md={6} sx={{ justifyContent: { xs: 'center', md: 'flex-end' } }}>
            <Box component={'img'} src={tokenLogo} sx={{ height: '70%', mr: { xs: 0, xl: 20 } }} />
          </Grid>
        </Grid>
        <Grid container sx={{ justifyContent: 'center' }}>
          <Typography variant="h2" sx={{ color: '#CA7729', fontSize: '34px', my: 2 }}>
            Use Taral For
          </Typography>
          <Grid container item xs={12} sx={{ justifyContent: 'space-between', mt: 2 }}>
            {cardData?.map((item, idx) => (
              <Grid
                item
                container
                xs={6}
                md={1.8}
                key={idx}
                sx={{
                  flexDirection: 'column',
                  gap: 2,
                  border: { md: `1px solid black` },
                  p: 1,
                  borderRadius: '10px'
                }}
              >
                <Avatar
                  sx={{
                    border: '1px solid black',
                    '&.MuiAvatar-root': {
                      backgroundColor: 'transparent'
                    }
                  }}
                >
                  <Typography variant="body2" className="displayCenter">
                    {idx + 1}
                  </Typography>
                </Avatar>
                <Typography variant="h3">{item.title}</Typography>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Section3;
{
  /* <Container maxWidth="xl">
<Title
  style={{ textAlign: 'center', color: '#CA7729', fontSize: '35px', fontWeight: 'bold', letterSpacing: '0.02em' }}
  variant={{ xs: 'h3', md: 'h2' }}
  className="sectionHeadingTitle"
>
  Scale Your Projects
</Title>
<Grid container alignItems="center" sx={{ mt: 6 }}>
  <Grid item xs={12} md={7}>
    <Box
      style={{
        background: 'url(/images/homepage/cardbg.png)',
        padding: '20px',

        borderRadius: '10px',
        alignItems: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
      }}
      sx={{
        height: { xs: '90%', md: 340 }
      }}
    >
      {cardData?.map((item, idx) => (
        <Box key={idx} sx={{ width: { xs: '100%', md: '70%' }, p: { xs: 0, xl: 1 } }}>
          <Grid container sx={{ flexDirection: 'row', gap: 2 }}>
            <Avatar src="" style={{ backgroundColor: '#000', height: '50px', width: '50px' }} />
            <Box sx={{ width: { xs: '100%', md: '80%' }, textAlign: 'left' }}>
              <Title variant={{ xs: 'h3', md: 'h2' }}> {item.title}</Title>
              <Typography
                style={{ fontSize: '12px', color: '#000', fontWeight: '500' }}
                variant="body1"
                sx={{ mt: 1, textAlign: 'left', letterSpacing: '0.05em' }}
                wrap
              >
                {item.subTitle}
              </Typography>
            </Box>
          </Grid>
          {idx !== cardData?.length - 1 && (
            <Divider
              style={{ margin: '17px 0' }}
              sx={{
                borderRightWidth: '1px',
                borderColor: '#cccccc'
              }}
            />
          )}
        </Box>
      ))}
    </Box>
  </Grid>
  <Grid item xs={12} md={5}>
    <Box height="100%">
      <Box
        sx={{
          height: { xs: '90%', md: 340 }
        }}
        component={'img'}
        width="100%"
        src="/images/card/cardimg.png"
        alt="cardimg"
      />
    </Box>
  </Grid>
</Grid>
</Container> */
}
